import VocButton from "./src/main"

/* istanbul ignore next */
VocButton.install = function (Vue) {
  Vue.component(VocButton.name, VocButton)
}

export default VocButton
